import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { getLegalDocByType } from '../../utils/legalAPIs'
import { toast } from 'react-toastify'
import styles from './DisplayLegalModal.module.scss'

const DisplayLegalModal = ({ show, setShow, linkText = '', legalType = null }) => {
  const [data, setData] = useState({ title: '', body: '' })
  const [isLoading, setIsLoading] = useState(true)

  const handleClose = () => setShow(false)
  const handleShow = (event) => {
    event.preventDefault()
    setShow(true)
  }

  const onShow = async () => {
    console.log('onShow', legalType)
    if (!legalType) {
      return
    }
    if (isLoading) setIsLoading(true)
    const response = await getLegalDocByType(legalType)
    if (response.data) {
      setData(response.data)
    } else {
      toast.error(`${response.message}`)
    }
  }

  return (
    <>
      <a href="#" role={'button'} onClick={handleShow}>
        {linkText}
      </a>

      <Modal show={show} onHide={handleClose} onShow={onShow} className="modal-kp5" size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{data.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.legalBody}>
          <div dangerouslySetInnerHTML={{ __html: data.body }} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default DisplayLegalModal
